import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-786b4408"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-authentication-layout" }
const _hoisted_2 = { class: "report-issue-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_information_icon = _resolveComponent("information-icon")!
  const _component_report_issue_button = _resolveComponent("report-issue-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_report_issue_button, null, {
        default: _withCtx(() => [
          _createVNode(_component_information_icon)
        ]),
        _: 1
      })
    ])
  ]))
}